<div class="pagination-counter-container">
	<span class="pagination-button" (click)="_currentPage != 1 ? (_currentPage = _currentPage - 1) : null; setNumberOfPages(false)"
		><fa-icon [icon]="icons.faAngleLeft"></fa-icon
	></span>
	<span
		class="pagination-button"
		[ngClass]="{ selected: _currentPage == i }"
		(click)="i != 0 ? (_currentPage = i) : null; i != 0 ? setNumberOfPages(false) : null"
		*ngFor="let i of numberOfPages"
		>{{ i != 0 ? i : '...' }}</span
	>
	<span class="pagination-button" (click)="_currentPage != maxPages ? (_currentPage = _currentPage + 1) : null; setNumberOfPages(false)"
		><fa-icon [icon]="icons.faAngleRight"></fa-icon
	></span>
</div>
